import {Item, ItemSubType} from '../../generated/types';
import {hasOnlySubType} from './get-item-sub-types';

export function getItemDexAcBonus(item: Item) {
	if (hasOnlySubType(item, ItemSubType.Light)) {
		return ' + мод. Лвк';
	} else if (hasOnlySubType(item, ItemSubType.Medium)) {
		return ' + мод. Лвк (не более 2)';
	} else {
		return '';
	}
}
